import React from 'react'
import Landing from '../routes/landings/Living'

const Living = () => {
  return <Landing />
}

export default Living
